export default "__VITE_ASSET__fNyJ7HbS__"